/**
 * Backdrop
 *
 * Full-screen overlay used to close the mobile sidebar when tapped.
 */
import React from 'react';
import { useSidebar } from '../../../context/sidebar';

function Backdrop() {
  const { isMobileOpen, toggleMobileSidebar } = useSidebar();

  if (!isMobileOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 lg:hidden"
      onClick={toggleMobileSidebar}
    />
  );
}

export default Backdrop;